import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useToast } from '@chakra-ui/react';
import { Pagination } from '~/types';
import { AnnouncementsView } from '~/types/announcements';
import {
  getAnnouncementPriority,
  getAnnouncements,
  getAnnouncementsNotifications,
} from '~/services/Announcements';
import { useRoleCan } from '~/hooks';

export function useAnnouncements(
  userIsAdmin: boolean,
  page: number,
  assunto = '',
  situacao = '',
  inicio = '',
  fim = '',
  page_size: number | undefined = undefined,
  order = 'DESC',
  options: UseQueryOptions<Pagination<AnnouncementsView>, unknown> = {},
): UseQueryResult<Pagination<AnnouncementsView>, unknown> {
  const toast = useToast();
  return useQuery<Pagination<AnnouncementsView>, unknown>(
    ['announcements', page, assunto, situacao, inicio, fim, page_size, order],
    () =>
      getAnnouncements(
        userIsAdmin,
        page,
        page_size,
        situacao,
        inicio,
        fim,
        assunto,
        order,
      ),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar comunicados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}

export function useAnnouncementsNotification(
  options: UseQueryOptions<AnnouncementsView[]> = {},
): UseQueryResult<AnnouncementsView[]> {
  const isAdmin = useRoleCan({ roles: ['administrador'] });
  const toast = useToast();
  return useQuery<AnnouncementsView[]>(
    ['announcementsNotifications'],
    () => getAnnouncementsNotifications(),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      enabled: !isAdmin,
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar comunicados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}

export function useAnnouncementsPriority(
  options: UseQueryOptions<AnnouncementsView> = {},
): UseQueryResult<AnnouncementsView> {
  const isAdmin = useRoleCan({ roles: ['administrador'] });
  const toast = useToast();
  return useQuery<AnnouncementsView>(
    ['announcementsPriority'],
    () => getAnnouncementPriority(),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      enabled: !isAdmin,
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar comunicados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}
